import { render, staticRenderFns } from "./AssistantEditor.vue?vue&type=template&id=3c82c9e8&scoped=true&"
import script from "./AssistantEditor.vue?vue&type=script&lang=js&"
export * from "./AssistantEditor.vue?vue&type=script&lang=js&"
import style0 from "./AssistantEditor.vue?vue&type=style&index=0&id=3c82c9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82c9e8",
  null
  
)

export default component.exports